import { ResponseData } from './response-data.type';
import { TaxResponseDocument } from './tax-response-document.model';
import { TaxResponseRecord } from './tax-response-record.model';

export class TaxResponseGroup {
    id = -1;
    index?: number;
    records = [] as TaxResponseRecord[];

    getGroupDocuments(): TaxResponseDocument[] {
        let res = [] as TaxResponseDocument[];
        this.records.forEach((record) => {
            if ((record.documents?.length ?? 0) > 0) {
                res.push(...record.documents!);
            }
        });
        return res;
    }

    gatherDocuments(): TaxResponseDocument[] {
        let res = [] as TaxResponseDocument[];
        this.records.forEach((record) => {
            if ((record.documents?.length ?? 0) > 0) {
                res.push(...record.documents!);
            }
            record.nestedGroups?.forEach((group) => res.push(...group.gatherDocuments()));
        });
        return res;
    }

    findFileRecordId(groupIndices: { groupId: number; nestedField?: number }[], fieldId: number): number | undefined {
        if (groupIndices.length == 1 && groupIndices[0].groupId === this.index) {
            return this.records.find((rec) => rec.inputField === fieldId)?.id;
        }
        if (groupIndices.length > 1) {
            const nestedRecord = this.records.find((rec) => rec.inputField === (groupIndices[0].nestedField ?? -1));
            const nestedGroup = nestedRecord?.nestedGroups?.find((group) => group.index === groupIndices[1].groupId);
            return nestedGroup?.findFileRecordId(groupIndices.slice(1), fieldId);
        }
        return undefined;
    }

    toDataMap(): ResponseData {
        let res = {} as ResponseData;
        this.records
            .filter((rec) => rec.nestedGroups === undefined)
            .forEach((rec) => {
                res[rec.inputField.toString()] = (rec.documents === undefined ? rec.data : rec.documents.map((doc) => doc.uuid)) ?? null;
            });
        return res;
    }

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.index = data.index ?? undefined;
        this.records = (data.records ?? []).map((rec: any) => new TaxResponseRecord().deserialize(rec));
        return this;
    }

    serialize() {
        return {
            id: this.id > 0 ? this.id : undefined,
            index: this.index,
            records: this.records.map((rec) => rec.serialize()),
        };
    }

    static Sort(item1: TaxResponseGroup, item2: TaxResponseGroup): number {
        return (item1.index ?? Infinity) - (item2.index ?? Infinity);
    }
}
